const Start = [
  {
    heroTitle: "How to register",
    subTitle: "How to create an account in Coinnik Market?",
    body: [
      "In the main menu, click on the Register / Login option to enter the login page.",
      "If you have an account, log in with your username (email) and password.",
      "If you do not have an account, click on Register.",
      "Enter the registration page information including first name, last name, email, selected password.",
      "If you have an identifier code, enter it. (Read about inviting friends).",
      "Click OK in the rules section (after reading the paragraphs in full).",
      "Confirm your email (an email containing the verification code will be sent to you).",
    ],
    content:
      "Now you have an account at coinnik Market and you can use our platform to buy and sell digital currencies instantly and cheaply.",
    firstContent: "Account_information",
    video: "https://www.aparat.com/video/video/embed/videohash/E4mJB/vt/frame",
  },
  {
    heroTitle: "How to Authentication",
    subTitle: "How is authentication done at coinnik Market?",
    content:
      "After completing your information at each level, you can enjoy the benefits of that user level.",
    body: [
      "There are four levels of authentication on our platform. The higher your authentication level, the lower your transaction restrictions.",
      "For level 1, enter the requested information including your first name, last name and national code and confirm your mobile number verification (the verification code will be sent to your number via SMS).",
      "For level 2, upload a picture of one of your IDs on the site (national card or passport or certificate).",
      "For level 3, send a selfie with your national card and handwritten text that you can see on the site. Also at this level you have to confirm your landline number and home address.",
      "For Level 4, book a ticket and announce your request to upgrade your authentication level.",
    ],
    firstContent: "Highest_level",
    video: "https://www.aparat.com/video/video/embed/videohash/E4mJB/vt/frame",
  },
  {
    heroTitle: "User loyalty level",
    subTitle: "How to create an account in Coinnik Market?",
    content:
      "There are currently 4 levels of loyalty in the coinnik Market trading platform.",
    body: [
      "If your trading volume in the last 30 days is below 50 million Tomans, you are at level 1 loyalty. Your commission fee is 0.29% and your order fee is 0.33%.",
      "If your trading volume in the last 30 days is between 50 and 200 million Tomans, you are at level 2 loyalty. Your commission fee is 0.19% and your order fee is 0.25%.",
      "If your trading volume in the last 30 days is between 200 and 350 million Tomans, you are at level 3 loyalty. Your commission fee is 0.15% and your order fee is 0.20%.",
      "If your trading volume in the last 30 days is more than 350 million Tomans, you are at level 4 loyalty. Your commission fee is 0.13% and your order fee is 0.18%.",
    ],
    firstContent: "Considered_monthly",
    video: "https://www.aparat.com/video/video/embed/videohash/2lHSK/vt/frame",
  },
];
export default Start;
